/* unplugin-vue-components disabled */import script from "./navigation-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./navigation-menu.vue?vue&type=script&setup=true&lang=ts"

import "./navigation-menu.vue?vue&type=style&index=0&id=3b64a662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b64a662"]])

export default __exports__